export type SortState = { by: string; dir: "asc" | "desc" };

/** Toggle a column: first click -> asc, second -> desc, third -> clear (back to default). */
export function nextSort(current: SortState | null, col: string): SortState | null {
  if (!current || current.by !== col) return { by: col, dir: "asc" };
  if (current.dir === "asc") return { by: col, dir: "desc" };
  return null;
}
